<div class="payment-group" data-cy="payment-group">
  <div class="body--s udex-mb-48 udex-mt-8">
    <udex-accordion-item [title]="'checkoutReview.paymentSection' | cxTranslate" [expanded]="expandAll">
      <div class="d-flex flex-column udex-py-24">
        <div class="payment-method w-100" data-cy="payment-method">
          <h6 class="navigation__medium--l">{{'orderReview.paymentMethod' | cxTranslate}}</h6>
          <div class="d-flex udex-mt-20">
            <img  class="udex-me-12" src="assets/images/checkout/review/invoice.svg" alt="Invoice" data-cy="icon"/>
            <span
              class="navigation__medium--l text-grey">{{'checkout.digitalNativeCheckout.paymentType.invoice.string' | cxTranslate}}</span>
          </div>
        </div>
        <div class="payment-addresses w-100 udex-mt-40" data-cy="payment-addresses">
          <div class="udex-grid udex-col-2 udex-col-sm-1 no-margin udex-px-0">
            <ng-container *ngFor="let address of paymentAddresses">
              <div class="udex-mb-20">
                <dcp-checkout-detail-section
                  data-cy="address-details"
                  [title]="'orderReview.paymentContactsSection.' + address?.addressUsage + '.title'"
                  [type]="DetailType.ADDRESS"
                  [address]="address"
                  [explainText]="componentTexts.infoBox[address?.addressUsage.toLowerCase()] ?? ('orderReview.paymentContactsSection.' + address?.addressUsage + '.explainText' | cxTranslate)"
                ></dcp-checkout-detail-section>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </udex-accordion-item>
    <udex-accordion-item [title]="'checkoutReview.contactsSection' | cxTranslate" [expanded]="expandAll">
      <div class="payment-contacts w-100 udex-mt-40" data-cy="payment-contacts">
        <div class="udex-grid udex-col-2 udex-col-sm-1 no-margin udex-px-0">
          <ng-container *ngFor="let address of contactAddresses">
            <div class="udex-mb-20">
              <dcp-checkout-detail-section
                data-cy="contact-details"
                [title]="'orderReview.paymentContactsSection.' + address?.addressUsage + '.title'"
                [type]="DetailType.CONTACT"
                [address]="address"
                [explainText]="componentTexts.infoBox[address?.addressUsage.toLowerCase()] ?? ('orderReview.paymentContactsSection.' + address?.addressUsage + '.explainText' | cxTranslate)"
              ></dcp-checkout-detail-section>
            </div>
          </ng-container>
        </div>
      </div>
    </udex-accordion-item>
  </div>
  <udex-divider></udex-divider>

</div>
